import "vant/es/popup/style";
import _Popup from "vant/es/popup";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
Vue.use(_Popup);
export default {
  data: function data() {
    return {};
  },
  props: {
    value: {
      type: Boolean
    },
    res: {
      type: Object
    }
  },
  components: {},
  methods: {
    handleConfirm: function handleConfirm() {
      this.$emit('input', this.res);
    }
  }
};